<template>
  <div>
    <v-progress-linear v-if="loadingCharts" indeterminate color="primary" class="mb-4"></v-progress-linear>

    <v-layout row wrap align-center class="mb-4">
      <v-flex xs12 sm5>
        <v-switch
          v-if="!isTransportationOwnerUser"
          v-model="showWeekendRevenue"
          label="Show Weekend Revenue Only"
          hide-details
          class="mt-0 pt-0"
        ></v-switch>
      </v-flex>
      <v-flex xs12 sm7 class="chart-view-toggle-wrap">
        <v-btn-toggle v-model="selectedChartView" mandatory class="chart-view-toggle">
          <v-btn
            v-for="option in chartViewOptions"
            :key="option.value"
            :value="option.value"
            small
            flat
          >
            {{ option.text }}
          </v-btn>
        </v-btn-toggle>
      </v-flex>
    </v-layout>

    <v-card class="mb-4">
      <v-card-title class="report-card-title">
        <h2>{{ dayChartRender.title }}</h2>
        <download-button
          label="CSV Download"
          download-type="text/csv;charset=utf-8"
          :file-name="buildChartCsvFileName(dayChart, 'day')"
          :on-download="downloadDayChartCsv"
          :button-attributes="{ small: true, color: 'primary', outline: true }"
          :disabled="loadingCharts || !dayChart.buckets.length"
        ></download-button>
      </v-card-title>
      <v-card-text>
        <st-apexchart
          type="bar"
          height="320"
          :options="dayChartOptions"
          :series="dayChartRender.series"
          :legend-reset-key="selectedChartView + '|' + (showWeekendRevenue ? '1' : '0')"
          :tooltip-total-label="tooltipTotalLabel"
          :tooltip-extra-html-by-index="dayChartTooltipExtras"
          :show-download-button="false"
        ></st-apexchart>
        <div v-if="!dayChartRender.hasData" class="mt-2">No data available for this period.</div>
      </v-card-text>
    </v-card>

    <v-card class="mb-4" v-if="chartVisibility.week">
      <v-card-title class="report-card-title">
        <h2>{{ weekChartRender.title }}</h2>
        <download-button
          label="CSV Download"
          download-type="text/csv;charset=utf-8"
          :file-name="buildChartCsvFileName(weekChart, 'week')"
          :on-download="downloadWeekChartCsv"
          :button-attributes="{ small: true, color: 'primary', outline: true }"
          :disabled="loadingCharts || !weekChart.buckets.length"
        ></download-button>
      </v-card-title>
      <v-card-text>
        <st-apexchart
          type="bar"
          height="320"
          :options="weekChartOptions"
          :series="weekChartRender.series"
          :legend-reset-key="selectedChartView + '|' + (showWeekendRevenue ? '1' : '0')"
          :tooltip-total-label="tooltipTotalLabel"
          :show-download-button="false"
        ></st-apexchart>
        <div v-if="!weekChartRender.hasData" class="mt-2">No data available for this period.</div>
      </v-card-text>
    </v-card>

    <v-card class="mb-4" v-if="chartVisibility.month">
      <v-card-title class="report-card-title">
        <h2>{{ monthChartRender.title }}</h2>
        <download-button
          label="CSV Download"
          download-type="text/csv;charset=utf-8"
          :file-name="buildChartCsvFileName(monthChart, 'month')"
          :on-download="downloadMonthChartCsv"
          :button-attributes="{ small: true, color: 'primary', outline: true }"
          :disabled="loadingCharts || !monthChart.buckets.length"
        ></download-button>
      </v-card-title>
      <v-card-text>
        <st-apexchart
          type="bar"
          height="320"
          :options="monthChartOptions"
          :series="monthChartRender.series"
          :legend-reset-key="selectedChartView + '|' + (showWeekendRevenue ? '1' : '0')"
          :tooltip-total-label="tooltipTotalLabel"
          :show-download-button="false"
        ></st-apexchart>
        <div v-if="!monthChartRender.hasData" class="mt-2">No data available for this period.</div>
      </v-card-text>
    </v-card>

    <v-card class="mb-4" v-if="chartVisibility.year">
      <v-card-title class="report-card-title">
        <h2>{{ yearChartRender.title }}</h2>
        <download-button
          label="CSV Download"
          download-type="text/csv;charset=utf-8"
          :file-name="buildChartCsvFileName(yearChart, 'year')"
          :on-download="downloadYearChartCsv"
          :button-attributes="{ small: true, color: 'primary', outline: true }"
          :disabled="loadingCharts || !yearChart.buckets.length"
        ></download-button>
      </v-card-title>
      <v-card-text>
        <st-apexchart
          type="bar"
          height="320"
          :options="yearChartOptions"
          :series="yearChartRender.series"
          :legend-reset-key="selectedChartView + '|' + (showWeekendRevenue ? '1' : '0')"
          :tooltip-total-label="tooltipTotalLabel"
          :show-download-button="false"
        ></st-apexchart>
        <div v-if="!yearChartRender.hasData" class="mt-2">No data available for this period.</div>
      </v-card-text>
    </v-card>
  </div>
</template>

<style scoped>
.chart-view-toggle-wrap {
  text-align: right;
}

.chart-view-toggle {
  max-width: 100%;
}

.report-card-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

@media (max-width: 960px) {
  .chart-view-toggle-wrap {
    text-align: left;
    margin-top: 8px;
  }
}
</style>

<script>
import src from './src'
export default src
</script>
